import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-198fee27"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "hero",
  ref: "heroRef"
}
const _hoisted_2 = { class: "container hero__container" }
const _hoisted_3 = { class: "hero__date" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "hero__date__line" }, null, -1))
const _hoisted_5 = { class: "hero__title" }
const _hoisted_6 = {
  key: 0,
  class: "hero__introduction"
}
const _hoisted_7 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TransitionImages = _resolveComponent("TransitionImages")!

  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _createVNode(_component_TransitionImages, { images: _ctx.images }, null, 8, ["images"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createTextVNode(_toDisplayString(_ctx.date), 1),
        (_ctx.date2)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _hoisted_4,
              _createTextVNode(" " + _toDisplayString(_ctx.date2), 1)
            ], 64))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("h1", _hoisted_5, _toDisplayString(_ctx.title), 1),
      (_ctx.introduction)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_ctx.introduction), 1))
        : _createCommentVNode("", true),
      (_ctx.image)
        ? (_openBlock(), _createElementBlock("img", {
            key: 1,
            class: "hero__image",
            src: _ctx.image
          }, null, 8, _hoisted_7))
        : _createCommentVNode("", true)
    ])
  ], 512))
}